import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const Input: React.FC<FormikFieldCustomProps &
  FieldProps & { handleBlur: () => {}; inline: any; }> = ({
    field: { ...fields },
    form: { touched, errors },
    ...props
  }) => (
      <Form.Group>
        {
          props.inline ?
            <React.Fragment>
              <Row className="align-items-center">
                <Col md={1} xs={2} sm={2}>
                  {props.label && (
                    <Form.Label>
                      {props.required ? <b>{props.label}</b> : props.label}
                      {props.required && <span className="text-danger">*</span>}
                    </Form.Label>
                  )}
                </Col>
                <Col>
                  <Form.Control
                    {...props}
                    {...fields}
                    onBlur={props.handleBlur}
                    onChange={(e: any) => {
                      if (fields.onChange) fields.onChange(e);
                    }}
                    isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors[fields.name]}
                  </Form.Control.Feedback>
                </Col>
              </Row>
            </React.Fragment>
            :
            <React.Fragment>
              {props.label && (
                <Form.Label>
                  {props.required ? <b>{props.label}</b> : props.label}
                  {props.required && <span className="text-danger">*</span>}
                </Form.Label>
              )}
              <Form.Control
                {...props}
                {...fields}
                onBlur={props.handleBlur}
                onChange={(e: any) => {
                  if (fields.onChange) fields.onChange(e);
                }}
                isInvalid={Boolean(touched[fields.name] && errors[fields.name])}
              />
              <Form.Control.Feedback type="invalid">
                {errors[fields.name]}
              </Form.Control.Feedback>
            </React.Fragment>
        }
      </Form.Group>
    );

export default Input;
